import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import type { ReleaseNoteDto } from '../../../../../../shared/models/release-notes.models';
import {
  AdminButtonComponent,
  AdminTableComponent,
  StatusBadgeComponent,
} from '../../../../../../shared/admin';

@Component({
  selector: 'app-release-management-table',
  standalone: true,
  imports: [DatePipe, AdminTableComponent, AdminButtonComponent, StatusBadgeComponent],
  templateUrl: './release-management-table.component.html',
  styleUrl: './release-management-table.component.scss',
})
export class ReleaseManagementTableComponent {
  readonly releases = input.required<ReleaseNoteDto[]>();
  readonly loading = input(false);
  readonly showEdit = input(true);
  readonly canEdit = input(true);
  readonly showCreate = input(true);
  readonly canCreate = input(true);
  readonly showPublish = input(true);
  readonly canPublish = input(true);

  readonly view = output<ReleaseNoteDto>();
  readonly edit = output<ReleaseNoteDto>();
  readonly duplicate = output<ReleaseNoteDto>();
  readonly publish = output<ReleaseNoteDto>();
  readonly unpublish = output<ReleaseNoteDto>();
  readonly remove = output<ReleaseNoteDto>();

  statusVariant(status: string): 'published' | 'draft' {
    return status === 'PUBLISHED' ? 'published' : 'draft';
  }

  creatorName(release: ReleaseNoteDto): string {
    return release.createdByUser?.displayName ?? release.createdBy ?? '—';
  }
}
